import { gql } from '@apollo/client';

export const fetchInvoiceGroupsForSearch = gql`
  query fetchInvoiceGroupsForOrderHistoryTableSearch(
    $searchOptions: ConnectionSearchOptions
    $filterOptions: FilterOption
    $transactionAccountId: ID!
  ) {
    invoiceGroups(
      searchOptions: $searchOptions
      filterOptions: $filterOptions
      transactionAccountId: $transactionAccountId
    ) {
      totalCount
      nodes {
        id
      }
    }
  }
`;
